import { styled } from '@naan/stitches.config';

export const ChapterItemContents = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  paddingLeft: 40,
});
